module.exports = __webpack_public_path__ + "img/thumb_16.01246e81.jpg";